import { getCurrentUser } from "../../firebaseModules/auth/auth";

const getInitialState = () => {
  const initialState = {
    user: null,
    isError: false,
  };

  const initialLoginData = getCurrentUser();
  if (initialLoginData) {
    // initialState.user = {
    //   name: initialLoginData.displayName,
    //   email: initialLoginData.email
    // };
  }

  return initialState;
}

export const authReducer = (state = getInitialState(), action) => {
  switch (action.type) {
    case "GOOGLE_LOGIN_SUCCESS":
      return {
        ...state,
        user: {
          ...action.payload.data,
          ...action.userInfo
        },
        isError: false,
      };
    case "GOOGLE_LOGIN_FAIL":
      return {
        ...state,
        isError: true,
      };
    default:
      return state;
  }
}
